module.exports = __webpack_public_path__ + "img/PEC8000_1-1.139ecb7f.jpg";